import { booleanAttribute, Component, input, output } from '@angular/core';
import { NgClass } from '@angular/common';

import { AppMaterialModule } from '../../../material.module';
import { IconComponent } from 'src/app/features/shared/icons/container/icon.component';
import { IconName } from 'src/app/features/shared/icons/icon-registry';
import { fieldAppearance, TFieldAppearance } from '../../models/form-field-options';
import { formFieldSize, TFormFieldSize } from '../../models/form-field-size';

// Eén chip: tekst + optioneel icoon. key identificeert de chip (track + verwijderen); zonder key telt de index.
export type TChipItem = { label: string; icon?: IconName | null; key?: string | null };

// Chips binnen het kader van een form-field (mat-chip-grid), met dezelfde opmaak als app-input-control: label,
// rand, hoogte, readonly-achtergrond en een optionele suffix-knop. Generiek: kent geen domein, alleen TChipItem.
// removable: verwijderknop per chip (chipRemove levert de chip); anders alleen weergave (bv. bewerken via een
// dialoog achter de suffix-knop). Bij veel chips loopt de rij door op een volgende regel en wordt het veld hoger.
@Component({
    selector: 'app-chips-control',
    templateUrl: './chips-control.component.html',
    styleUrls: [
        './chips-control.component.scss',
        '../../control.scss',
    ],
    standalone: true,
    host: {
        '[class.readonly]': 'input_readonly$$()',
    },
    imports: [
        AppMaterialModule,
        IconComponent,
        NgClass,
    ],
})
export class ChipsControlComponent
{
    input_appearance$$    = input<TFieldAppearance>(fieldAppearance.fill,  { alias: 'appearance' });
    input_classHeight$$   = input<TFormFieldSize>(formFieldSize.defHeight, { alias: 'classHeight' });
    input_emptyText$$     = input<string>('',                              { alias: 'emptyText' });
    input_error$$         = input<string | null>(null,                     { alias: 'error' });
    input_items$$         = input<TChipItem[]>([],                         { alias: 'items' });
    input_label$$         = input<string>('',                              { alias: 'label' });
    input_readonly$$      = input(false,                                   { transform: booleanAttribute, alias: 'readonly' });
    input_removable$$     = input(false,                                   { transform: booleanAttribute, alias: 'removable' });
    input_removeTooltip$$ = input<string>('remove',                        { alias: 'removeTooltip' });
    input_required$$      = input(false,                                   { transform: booleanAttribute, alias: 'required' });
    input_suffixIcon$$    = input<string | null>(null,                     { alias: 'suffixIcon' });
    input_suffixTooltip$$ = input<string | null>(null,                     { alias: 'suffixTooltip' });

    out_chipRemove  = output<TChipItem>({ alias: 'chipRemove' });
    out_suffixClick = output<void>({ alias: 'suffixClick' });

    trackChip(index: number, item: TChipItem): string | number {
        return item.key ?? index;
    }

    emit_chipRemove(item: TChipItem): void {
        this.out_chipRemove.emit(item);
    }

    emit_suffixClick(event: MouseEvent): void {
        event.stopPropagation();
        this.out_suffixClick.emit();
    }
}
